import './index.scss'

class OCETextMedia {
    constructor(el) {
        this.$el = el

        // console.log('TextMedia::constructor')
    }
    init() {
        this.$poster = this.$el.querySelector('.oce-text-media__poster')
        this.$iframe = this.$el.querySelector('iframe')

        const controlVideo = (control, id) => {
            var iframe = id.contentWindow;
            iframe.postMessage(
              '{"event":"command","func":"'+ control +'","args":""}',
              "*"
            );
        }
        
        this.$poster.addEventListener('click', () => {
            controlVideo('playVideo', this.$iframe)
            this.$poster.style.opacity = '0'
            this.$poster.style.pointerEvents = 'none'
        }, {capture: true, passive: true, once: true} || true)
        
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-text-media') ].forEach($block => {
        $block.expandygg = new OCETextMedia($block)
    })
}, {capture: false, passive: true, once: true} || false)